<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content *ngIf="isLoaded">

  <div *ngIf="!dynamicContentPackages || !dynamicContentPackages.length" class="no-data">
    <h2>{{'packages.list.no_packages' | translate}}</h2>
  </div>

  <data-table (detail)="onDetail($event)"
                  *ngIf="dynamicContentPackages && dynamicContentPackages.length"
                  [columns]="columns"
                  [plainData]="dynamicContentPackages"
                  title="Choose your Package"
  ></data-table>

</page-content>
